// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"728":"3828fcc7","864":"19fefeea"}[chunkId] + ".chunk.js";
};